<section class="page-section overlay" id="branded-background">
    <div class="overlay-center-parent">
        <div class="overlay-center-child">
            <div class="row">
                <div class="col-0 col-md-1 col-lg-2 col-xl-2 hide-xs-sm"></div>
                <div class="col-12 col-md-10 col-lg-8 col-xl-8">
                    <div class="overlay-card">
                        <div class="row">
                            <div class="col-12 center-middle">
                                <h1 class="page-title">Camera access error</h1>
                            </div>
                        </div>
                        <div class="row overlay-row">
                            <div class="col-12">
                                <div class="row row-form form-banner">
                                    <div class="col-3 col-sm-2 col-lg-3 col-xl-2 text-align-center">
                                        <div class="form-banner-center-parent">
                                            <div class="form-banner-center-child">
                                                <i class="fas fa-exclamation-circle fa-3x"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-9 col-sm-10 col-lg-9 col-xl-10">
                                        <div class="form-banner-center-parent">
                                            <div class="form-banner-center-child">
                                                <span>Please review your browser permissions and try again.</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 col-sm-6 btn-order-left text-align-center">
                                <button type="button" class="btn btn-secondary-v2 btn-margins btn-label btn-label-back" (click)="back()"><span class="btn-icon btn-icon-back"></span></button>
                            </div>
                            <div class="col-12 col-sm-6 btn-order-right text-align-center">
                                <button type="button" class="btn btn-primary-v2 btn-margins btn-label btn-label-try-again" (click)="tryAgain()"><span class="btn-icon btn-icon-try-again"></span></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-0 col-md-1 col-lg-2 col-xl-2 hide-xs-sm"></div>
            </div>
        </div>
    </div>
</section>
